const isGoogleBot = (currentAgent?: string) => {
  const userAgent = currentAgent ? currentAgent : window.navigator.userAgent;
  const isGoogleBot = /googlebot|chrome-lighthouse/i.test(userAgent);
  return isGoogleBot;
};

export default isGoogleBot;
